import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
// import styles from '../styles/NewPasswordForm.css'; // Create CSS for this form
import axios from "axios"; // <-- FIX 1: Import axios to make API calls

const API_URL = `${process.env.REACT_APP_NODE_URL}/api`; // Adjust if your backend URL or port is different

const NewPasswordForm = () => {
  const { token } = useParams(); // Get token from URL '/set-new-password/:token'
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'success' or 'error'
  const [isTokenValid, setIsTokenValid] = useState(true); // Optional: Pre-check token validity

  // Optional: You could add a check here on component mount to see if the token
  // format looks okay, or even make a lightweight backend call to verify
  // its existence without resetting (though this adds complexity).
  useEffect(() => {
    if (!token) {
      setMessage("Invalid or missing reset token.");
      setMessageType("error");
      setIsTokenValid(false);
      // Maybe redirect or show a specific error state
    }
  }, [token]);

  const handleSetNewPassword = async (e) => {
    e.preventDefault();
    setMessage("");
    setMessageType("");

    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      setMessageType("error");
      return;
    }

    if (password.length < 8) {
      // Basic validation
      setMessage("Password must be at least 8 characters long.");
      setMessageType("error");
      return;
    }

    setIsLoading(true);

    try {
      // **BACKEND API CALL WITH AXIOS**
      // Pass the token in the URL and password in the body
      const response = await axios.post(
        `${API_URL}/password-forgot/set-new-password/${token}`,
        { password }
      );

      // Axios automatically parses JSON, so no need for .json()
      setMessage(response.data.message || "Password reset successfully!");
      setMessageType("success");

      localStorage.clear();

      // Clear form
      setPassword("");
      setConfirmPassword("");

      // Redirect to login after a short delay
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (error) {
      console.error("Error setting new password:", error);

      // Axios errors may have `error.response.data`
      const errMsg =
        error.response?.data?.message ||
        error.message ||
        "Failed to reset password. The link may be invalid or expired.";

      setMessage(errMsg);
      setMessageType("error");

      if (errMsg.toLowerCase().includes("invalid or expired")) {
        setIsTokenValid(false);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    // Basic structure - style as needed
    <div className="new-password-main-container">
      <div className="new-password-container">
        <h1 className="new-password-title">Set New Password</h1>

        {message && (
          <div
            className={`message ${
              messageType === "success" ? "message-success" : "message-error"
            }`}
          >
            {message}
          </div>
        )}

        {isTokenValid ? (
          <form onSubmit={handleSetNewPassword} className="new-password-form">
            <p>Enter and confirm your new password.</p>
            <div className="form-group">
              <label htmlFor="password">New Password</label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength="8"
                disabled={isLoading || messageType === "success"}
                className="new-password-input"
                placeholder="Enter new password"
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm New Password</label>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                minLength="8"
                disabled={isLoading || messageType === "success"}
                className="new-password-input"
                placeholder="Confirm new password"
              />
            </div>
            {/* Optional: Add password strength indicator */}

            <button
              type="submit"
              className="new-password-submit-button"
              disabled={isLoading || messageType === "success"}
            >
              {isLoading ? "Setting Password..." : "Set New Password"}
            </button>
          </form>
        ) : (
          <p>
            This password reset link is invalid or has expired. Please request a
            new one.
          </p>
          // Optionally add a button/link to go back to the request reset form
        )}
        {/* Link back to login */}
        {messageType !== "success" && isTokenValid && (
          <p style={{ marginTop: "20px", textAlign: "center" }}>
            Remember your password? <a href="/login">Login here</a>
          </p>
        )}
      </div>
      {/* Re-use message styles or create specific ones */}
      <style jsx>{`
        .new-password-main-container {
          /* Center the form, etc */
        }
        .new-password-container {
          max-width: 400px;
          margin: 40px auto;
          padding: 30px;
          border: 1px solid #ccc;
          border-radius: 8px;
          background-color: #fff;
        }
        .new-password-title {
          text-align: center;
          margin-bottom: 20px;
        }
        .form-group {
          margin-bottom: 15px;
        }
        .form-group label {
          display: block;
          margin-bottom: 5px;
          font-weight: bold;
        }
        .new-password-input {
          width: 100%;
          padding: 10px;
          border: 1px solid #ccc;
          border-radius: 4px;
          box-sizing: border-box;
        }
        .new-password-submit-button {
          width: 100%;
          padding: 12px;
          background-color: #007bff;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-size: 16px;
        }
        .new-password-submit-button:disabled {
          background-color: #cccccc;
          cursor: not-allowed;
        }
        .new-password-submit-button:hover:not(:disabled) {
          background-color: #0056b3;
        }
        .message {
          padding: 10px;
          margin-bottom: 15px;
          border-radius: 4px;
          text-align: center;
        }
        .message-success {
          background-color: #d4edda;
          color: #155724;
          border: 1px solid #c3e6cb;
        }
        .message-error {
          background-color: #f8d7da;
          color: #721c24;
          border: 1px solid #f5c6cb;
        }
      `}</style>
    </div>
  );
};

export default NewPasswordForm;
